import { render, staticRenderFns } from "./approval-list.vue?vue&type=template&id=5c94eb0c&scoped=true"
import script from "./approval-list.vue?vue&type=script&lang=js"
export * from "./approval-list.vue?vue&type=script&lang=js"
import style0 from "./approval-list.vue?vue&type=style&index=0&id=5c94eb0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c94eb0c",
  null
  
)

export default component.exports